import { Mask } from './mask'

export type { MaskProps } from './mask'

export default Mask
